import React from 'react';
// import Icofont from 'react-icofont';
// import { useSelector } from 'react-redux';
import { getItemStepz } from 'src/helpers/localstorage';
import { TarjetaDeCredito } from './TarjetaCredito';
import { Yappy } from './Yappy';
import ResumenPago from '../1-seleccionepoliza/ResumenPago';
import { useMediaQuery } from 'react-responsive';
import { Clave } from './Clave';
// import { useSelector } from 'react-redux';

const Pagar = ({
    step,
    stepBackwards,
    stepForward
}) => {

    // const { loadingResponse } = useSelector(state => state.pago);
    const isMobile = useMediaQuery({ maxWidth: 768 });


    return (
        <React.Fragment>
            <ResumenPago
                step={step}
                stepForward={stepForward}
                stepBackwards={stepBackwards}
                fixed={isMobile}
            />
            <div className='justify-content-center'>
                {
                    parseFloat(getItemStepz()?.pay) === parseFloat(process.env.REACT_APP_ID_ORIGEN_TARJETA_CREDITO)
                    && (
                        <TarjetaDeCredito
                            step={step}
                            stepForward={stepForward}
                        />
                    )
                }

                {
                    parseFloat(getItemStepz()?.pay) === parseFloat(process.env.REACT_APP_ID_ORIGEN_YAPPY)
                    && (
                        <Yappy 
                            step={step}
                            stepForward={stepForward}
                        />
                    )
                }

                     {
                    parseFloat(getItemStepz()?.pay) === parseFloat(process.env.REACT_APP_ID_ORIGEN_CLAVE)
                    && (
                        <Clave 
                            step={step}
                            stepForward={stepForward}
                        />
                    )
                }
                <br />

            </div>
        </React.Fragment>
    )
}

export default Pagar